import React, { useMemo } from "react";
import { Typography } from "../Typography/Typography";
//
import { useFieldErrorMessage } from "../inputUtils";
import type { FieldError } from "react-hook-form";

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  isRequired: boolean;
  hookFormFieldError: FieldError | undefined;
}

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
  const { label, isRequired, hookFormFieldError, ...inputProps } = props;

  const error = useFieldErrorMessage(hookFormFieldError);

  const inputStyle = useMemo(() => {
    const borderClassName = error ? "border-red" : "border-grey";
    return `${borderClassName} mt-1 min-h-12 min-w-full rounded-xl border pl-2`;
  }, [error]);

  return (
    <>
      <Typography className={error ? "text-red" : ""}>
        {props.label}
        {isRequired ? "*" : ""}
      </Typography>
      <input {...inputProps} className={inputStyle} ref={ref} />
      {error ? <p className="text-red">{error} </p> : null}
    </>
  );
});

TextInput.displayName = "TextInput";
